import { useJobFormUpdateJobDraftMutation } from "../use-job-form-update-job-draft-mutation";

export const useIsSavingJobDraft = () => {
  const [, { isLoading }] = useJobFormUpdateJobDraftMutation();

  return { isSavingJobDraft: isLoading };
};
